module.exports = __webpack_public_path__ + "static/media/7.30f628d5.JPG";